/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';

interface IProps {
  content: string;
}

const Wrapper = styled.div``;

const ShelfContent: React.FC<IProps> = ({ content }) => {
  return (
    <Wrapper>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Wrapper>
  );
};
// TODO: default html 만들기 (ex: 홈으로가기)

export default ShelfContent;
